define(["jquery"], function ($) {
    "use strict";

    return function () {
        try {
            const breakpoints = $.parseQuery(
                getComputedStyle(document.querySelector(".foundation-mq"))[
                    "font-family"
                ].replace(/"/g, "")
            );

            let mediumBreakpoint = Math.floor(
                parseFloat(breakpoints.medium) * 16
            );
            return window.innerWidth > mediumBreakpoint;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return false;
        }
    };
});
